var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgK1SwitchScene(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53 18l-10-8 10-8v6h13v14h6l-8 10-8-10h6V12h-9v6zm-4 24h1.63l5.64 6h5.38l-5.87-6h5.57L67 47.78V65H35v-7h-4v11h40V39H49v3zm-4 12H5V25h40v29zm-4-19l-5.86-6h-5.6l5.87 6h-5.48l-5.65-6h-5.5l5.65 6h-4.72l-5.65-6H9l5.22 6H9v15h32V35zm-1.47-19.68l-2-7.41L3 17.25l2 7.41 34.53-9.34z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/K1_Switch_scene.d5a9335e.svg";
export { SvgK1SwitchScene as ReactComponent };